import { __read, __spread, __values } from "tslib";
var isChoicesEqual = function (a, b) {
    return typeof a !== 'undefined' && typeof b !== 'undefined' && a.id === b.id;
};
var isChoicesListsEqual = function (aChoices, bChoices) {
    if (aChoices.length !== bChoices.length) {
        return false;
    }
    return aChoices.every(function (aChoice, i) {
        var bChoice = bChoices[i];
        return isChoicesEqual(aChoice, bChoice);
    });
};
export var isChoicesMapsEqual = function (m1, m2) {
    var e_1, _a;
    if (m1.size !== m2.size) {
        return false;
    }
    try {
        for (var m1_1 = __values(m1), m1_1_1 = m1_1.next(); !m1_1_1.done; m1_1_1 = m1_1.next()) {
            var _b = __read(m1_1_1.value, 2), key1 = _b[0], val1 = _b[1];
            if (!isChoicesEqual(m2.get(key1), val1)) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (m1_1_1 && !m1_1_1.done && (_a = m1_1.return)) _a.call(m1_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
export var findIndexFromTail = function (choices, choice) {
    if (choices === void 0) { choices = []; }
    var i = choices.length;
    while (i > 0) {
        i -= 1;
        if (isChoicesEqual(choices[i], choice)) {
            return i;
        }
    }
    return -1;
};
export var findIndexFromHead = function (choices, choice) {
    if (choices === void 0) { choices = []; }
    return choices.findIndex(function (possibleTheSameChoice) { return isChoicesEqual(possibleTheSameChoice, choice); });
};
var sortByChoices = function (choices, subset) {
    return subset.slice(0).sort(function (a, b) { return findIndexFromHead(choices, a) - findIndexFromHead(choices, b); });
};
var isOutOfRange = function (choices, index) {
    return index < 0 || index > choices.length - 1;
};
export var findPrevPicked = function (choices, picked, append) {
    if (choices === void 0) { choices = []; }
    var lastPicked = picked[picked.length - 1];
    var lastPickedIndex = findIndexFromHead(choices, lastPicked);
    var prevPickedIndex = lastPickedIndex === -1 ? choices.length : lastPickedIndex;
    do {
        prevPickedIndex -= 1;
        if (isOutOfRange(choices, prevPickedIndex)) {
            if (append) {
                return picked;
            }
            return [];
        }
        if (findIndexFromHead(picked, choices[prevPickedIndex]) > -1) {
            if (!append) {
                return picked.slice(-2, -1);
            }
            var sortPicked = sortByChoices(choices, picked);
            if (lastPicked === sortPicked[sortPicked.length - 1]) {
                return picked.slice(0, -1);
            }
            continue;
        }
        if (append) {
            return __spread(picked, [choices[prevPickedIndex]]);
        }
        return [choices[prevPickedIndex]];
    } while (true); // eslint-disable-line no-constant-condition
};
export var findNextPicked = function (choices, picked, append) {
    if (choices === void 0) { choices = []; }
    var lastPicked = picked[picked.length - 1];
    var lastPickedIndex = findIndexFromTail(choices, lastPicked);
    var nextPickedIndex = lastPickedIndex;
    do {
        nextPickedIndex += 1;
        if (isOutOfRange(choices, nextPickedIndex)) {
            if (append) {
                return picked;
            }
            return [];
        }
        if (findIndexFromTail(picked, choices[nextPickedIndex]) > -1) {
            if (!append) {
                return picked.slice(-2, -1);
            }
            var sortPicked = sortByChoices(choices, picked);
            if (lastPicked === sortPicked[0]) {
                return picked.slice(0, -1);
            }
            continue;
        }
        if (append) {
            return __spread(picked, [choices[nextPickedIndex]]);
        }
        return [choices[nextPickedIndex]];
    } while (true); // eslint-disable-line no-constant-condition
};
var uniChoices = function (choices) {
    var e_2, _a;
    var result = [];
    try {
        for (var choices_1 = __values(choices), choices_1_1 = choices_1.next(); !choices_1_1.done; choices_1_1 = choices_1.next()) {
            var choice = choices_1_1.value;
            if (findIndexFromTail(result, choice) === -1) {
                result.push(choice);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (choices_1_1 && !choices_1_1.done && (_a = choices_1.return)) _a.call(choices_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
};
export var setChoicesSubset = function (choices, subset, maxChoices) {
    var uniques = uniChoices(subset);
    // eslint-disable-next-line no-nested-ternary
    var newChoices = isFinite(maxChoices) ?
        (maxChoices < 1 ?
            [] :
            uniques.slice(Math.min(uniques.length, maxChoices) * -1)) :
        uniques;
    if (isChoicesListsEqual(choices, newChoices)) {
        return choices;
    }
    return newChoices;
};
export var addChoicesSubset = function (choices, subset, maxChoices) {
    var newChoices = __spread(choices, subset);
    return setChoicesSubset(choices, newChoices, maxChoices);
};
export var delChoicesSubset = function (choices, subset, maxChoices) {
    var newChoices = subset.reduce(function (acc, delChoice) { return acc.filter(function (c) { return !isChoicesEqual(delChoice, c); }); }, choices);
    return setChoicesSubset(choices, newChoices, maxChoices);
};
export var hasChoicesSubset = function (choices, subset) {
    return subset.every(function (hasChoice) { return findIndexFromTail(choices, hasChoice) > -1; });
};
export var eventHandler = function () {
    // Noop
};
export var scrollToElem = function (elem) {
    if (!elem) {
        return;
    }
    elem.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'nearest',
    });
};
